import React, { Fragment, useCallback, useRef } from "react";
import { BarcodeKeyboardScanner } from "../barcode-keyboard-scanner/barcode-keyboard-scanner";
import { CameraScanner } from "../camera-scanner/camera-scanner";
import { CodeScannerMenu } from "./code-scanner-menu";
import { CameraListLoader } from "../camera-scanner/camera-list-loader";
import { CodeScannerMode, useCodeScannerOptions } from "./code-scanner-settings-context";
import { useScannerContext } from "../../context/app-context/code-scanner-context/code-scanner-context";
import { useScanner as useKeyboardScanner } from "../../../common/hooks/use-scanner";

import "./style.scss";

export enum CodeScannerFormat {
    BARCODE,
    QR_CODE,
}

interface ICodeScannerProps {
    formats: CodeScannerFormat[];
    onValueScanned: ((value: string) => void) | undefined;
    onKeyboardValueScanned: ((value: string) => void) | undefined;
}

export const CodeScanner = (props: ICodeScannerProps) => {
    const scanner = useScannerContext();
    const scannerOptions = useCodeScannerOptions();
    const animation = useRef(Math.random() > 0.5 ? 1 : 2);

    useKeyboardScanner(props.onValueScanned || (() => ({})), props.onValueScanned !== undefined);
    useKeyboardScanner(props.onKeyboardValueScanned || (() => ({})),
        props.onKeyboardValueScanned !== undefined && props.onValueScanned === undefined);

    const handleDeviceListLoaded = useCallback((list: MediaDeviceInfo[]) =>
        scannerOptions.onCameraDevicesListUpdated(list), [scannerOptions]);
    const handleCameraAccessFailed = useCallback(() =>
        scannerOptions.onCameraAccessFailed(), [scannerOptions]);

    return <Fragment>
        {scanner.onCodeScanned && <CodeScannerMenu />}
        <div className={"scanner"}>
            {scannerOptions.scanMode === CodeScannerMode.BarcodeScanner &&
                <div className={"scan-and-ship__background"} data-animation={animation.current}></div>}
            {scannerOptions.scanMode === CodeScannerMode.BarcodeScanner ?
                <BarcodeKeyboardScanner onValueScan={props.onValueScanned} /> :
                !scannerOptions.cameraDevicesList ?
                    <CameraListLoader onLoad={handleDeviceListLoaded}
                                      onCameraAccessDenied={handleCameraAccessFailed} /> :
                    <CameraScanner formats={props.formats} onValueScan={props.onValueScanned} />}
        </div>
    </Fragment>;
};
